module.exports = __webpack_public_path__ + "media/images/digivent/digivent_bg-dc1e4bb1b8a80329608726a88367b32c.jpg";